import React from 'react';

import PropTypes from 'prop-types';

const ChatsIcon = ({ color = 'currentColor', size = '1em', ...rest }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.688 19.112V3.112H3.312V21.8L6 19.112H24.688ZM24.688 0.487999C25.4133 0.487999 26.032 0.743999 26.544 1.256C27.056 1.768 27.312 2.38667 27.312 3.112V19.112C27.312 19.8373 27.056 20.4667 26.544 21C26.032 21.5333 25.4133 21.8 24.688 21.8H6L0.688 27.112V3.112C0.688 2.38667 0.944 1.768 1.456 1.256C1.968 0.743999 2.58667 0.487999 3.312 0.487999H24.688Z"
        fill={color}
      />
    </svg>
  );
};

ChatsIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ChatsIcon;
